import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';

import TabImage from '../assets/images/about/06.webp';

function ECommerceSolution() {
  return (
    <>
      <Row>
        <Col lg={4} md={5}>
          <img className="img-fluid" src={TabImage} alt="" />
        </Col>
        <Col lg={5} md={7} className="mt-4 mt-md-0">
          <h4 className="mb-4">
            Explore our wide Range of E-commerce Solutions
          </h4>
          <ul className="list-unstyled list-number">
            <li className="mb-2">
              <span>01</span>Hassle-free setup & administration
            </li>
            <li className="mb-2">
              <span>02</span>Customizable as required
            </li>
            <li className="mb-2">
              <span>03</span>Lifetime free update
            </li>
            <li className="mb-2">
              <span>04</span>Robust admin & reporting features
            </li>
            <li className="mb-2">
              <span>05</span>Six months FREE support for bugs
            </li>
          </ul>
          <h6>
            Package start from <b className="text-primary font-xll">$600</b>
          </h6>
        </Col>
        <Col lg={3} md={12} className="text-center mt-4 mt-lg-0">
          <div className="bg-light h-100 p-4">
            <div className="badge-round mt-2">
              <h4 className="text-white">
                <span className="d-block font-xlll">30+</span> Million
              </h4>
            </div>
            <p className="mt-3">
              Revenue generated by our partner and clients since 2005
            </p>
            <a className="btn btn-link link-primary mt-3" href="/case-study">
              View Case Study
            </a>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default ECommerceSolution;
